import { render, staticRenderFns } from "./LeaverList.vue?vue&type=template&id=0f4a6d0e&"
import script from "./LeaverList.vue?vue&type=script&lang=js&"
export * from "./LeaverList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports